import { AndFilters, OrFilters } from "features/Rsql/types/RsqlFilters";
import { buildRsqlString } from "features/Rsql/utils/buildRsqlString";
import Sorting from "hooks/api/types/Sorting";

export default function getRsqlQueryString<T>(options: {
  rsqlFilters?: OrFilters<T> | AndFilters<T>;
  sorting?: Sorting<T>;
  additionalParams?: string[];
}) {
  const { rsqlFilters, sorting, additionalParams } = options;
  const parts: string[] = [...(additionalParams || [])];

  if (sorting)
    parts.push(
      `sort=${sorting
        .map(
          (sort) =>
            `${sort.sortBy}${sort.direction ? `:${sort.direction}` : ""}`,
        )
        .join(",")}`,
    );

  const rsqlString = buildRsqlString<T>(rsqlFilters);
  if (rsqlString) parts.push(rsqlString);

  return parts.join("&");
}
